import { BUTTON_AND_DROPDOWN_CONTAINER_BLOCK, CONSENT_BLOCK, CONTINUE_BUTTON_BLOCK, DEFAULT_BLOCKS, TCPA_BUTTONS_BLOCK, TCPA_DROPDOWN_BLOCK, TITLE_BLOCK } from "../blocks";

export default [
  ...DEFAULT_BLOCKS,
  BUTTON_AND_DROPDOWN_CONTAINER_BLOCK,
  TITLE_BLOCK,
  CONSENT_BLOCK,
  TCPA_BUTTONS_BLOCK,
  CONTINUE_BUTTON_BLOCK,
  TCPA_DROPDOWN_BLOCK,
  {
    key: "button-and-dropdown-answers",
    template: `
      {{>tcpa-buttons}}
      <div class="tcpa-answers-row">
        {{>tcpa-dropdown}}
      </div>
      {{>continue-button}}
    `,
  },
]
